import type { ProjectCreatedEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const ProjectCreatedIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<rect x="2" y="2.5" width="12" height="11" rx="1" />
		<path d="M5 2.5v2M11 2.5v2M2 7h12" />
	</svg>
)

export function ProjectCreatedRow({ event }: { event: ProjectCreatedEvent }) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	return (
		<JournalRowShell
			icon={<ProjectCreatedIcon />}
			headline={t.journal.events.projectCreated.label}
			actor={actor}
			iso={event.createdAt}
			eventType="project.created"
			aria={interpolate(t.journal.events.projectCreated.aria, { actor })}
		/>
	)
}
